import React from "react";
import { useLocation, useParams } from "react-router-dom";
import Residential from '../../images/liaison/micro-landing/residential.png'
import Industry from '../../images/liaison/micro-landing/industry.png'
import Educational from '../../images/liaison/micro-landing/educational.png'
import Healthcare from '../../images/liaison/micro-landing/healthcare.png'
import mockup from '../../images/liaison/micro-landing/dtcp_mockup.png'
import approach from '../../images/liaison/micro-landing/assessment_icon.png'
import feasibility from '../../images/liaison/micro-landing/feasibiliity_icon.png'
import expertopinion from '../../images/liaison/micro-landing/expertopinion_icon.png'
import designdrawing from '../../images/liaison/micro-landing/design_drawings_icon.png'
import NOC from '../../images/liaison/micro-landing/NOC_icon.png'
import onlinesubmission from '../../images/liaison/micro-landing/onlinesub_icon.png'
import dtcpcoordination from '../../images/liaison/micro-landing/dtcp_coordination_icon.png'
import localbody from '../../images/liaison/micro-landing/localbody_icon.png'
import approvaldocuments from '../../images/liaison/micro-landing/approval_icon.png'
import validity from '../../images/liaison/micro-landing/validity_icon.png'
import delivery from '../../images/liaison/micro-landing/delivery_icon.png'
import subdivision from '../../images/liaison/micro-landing/subdivision_icon.png'
import line from '../../images/liaison/micro-landing/line.png'
import insidebanner from '../../images/liaison/micro-landing/inside_banner.png'
import dtcp_banner from '../../images/liaison/micro-landing/dtcp_banner.png'
import landuse_banner from '../../images/liaison/micro-landing/landuse_banner.png'
import layoutapproval_banner from '../../images/liaison/micro-landing/layoutapproval_banner.png'
import hacanoc_banner from '../../images/liaison/micro-landing/hacanoc_banner.png'

import Banner from "../Banner";
import Milestones from "../../Card-Components/milestones";
import Testimonial from '../Testimonial'
import Chatwithus from '../chatwithus'

function Liasion_Description(){

    let params = useParams();
    const path = params.micro_id;
    
    let data = {
        dtcp: {
            banner_image: {
                image: dtcp_banner,
                title: "Simplify your life",
                subtitle: "Property Approval Services",
                textposition: "w-[550px] top-[240px] right-[152px]"
            },
                heading: "DTCP Building Plan Approval",
                description: "If you are building a residence, commercial property, industry, or institution, we assist you in obtaining approvals for your building plan in compliance with the regulations of the Directorate of Town and Country Planning (DTCP)",
                compliance: [
                {
                    image: approach,
                    heading: "Approach and proximity",
                    content: "Assessment of public road access to the landd",
                    heading_class: "w-[220px] sm:w-[159px]",
                    image_class: "w-[66px] h-[70px]",
                    content_class:"w-[220px] sm:w-[153px]"
                },
                {
                    image: subdivision,
                    heading: "Sub-division and detailed review",
                    content: "Review of subdivision in compilance to survey records",
                    heading_class: "w-[220px] sm:w-[153px]",
                    image_class: "w-[81px] h-[85px]",
                    content_class:"w-[220px] sm:w-[153px]",
                    line:true
                },
                {
                    image: feasibility,
                    heading: "Feasibility Study",
                    content: "Approaches that will lead to cost, time and regulatory process",
                    heading_class: "w-[220px] sm:w-[131px]",
                    image_class: "w-[87px] h-[91px]",
                    content_class:"w-[220px] sm:w-[152px]",
                    line: true,
                }

            ],
            filepreparation: [
                {
                  image: expertopinion,
                  heading:"Legal Opinion",
                  content: "Legal clarity to the property via opinion from expert lawyers",  
                  heading_class: "w-[220px] sm:w-[179px]",
                  image_class:"w-[75px] h-[75px]",
                  content_class: "w-[220px] sm:w-[160px]"
                },
                {
                    image:designdrawing,
                    heading:"Design drawings",
                    content: "Assessment of building plan in accordance with the regulations",
                    heading_class: "w-[220px] sm:w-[150px]",
                    image_class: "w-[86px] h-[73px]",
                    content_class:"w-[220px] sm:w-[160px]",
                    line:true
                },
                {
                    image: NOC,
                    heading: "Undertakings and NOC",
                    content: "No-objection certificates from one of the 13 departments whichever is applicable",
                    heading_class:"w-[220px] sm:w-[223px]",
                    image_class: "w-[56px] h-[74px]",
                    content_class:"w-[220px] sm:w-[182px]",
                    line:true

                }
            ],
            submission: [
                {
                    image: onlinesubmission,
                    heading: "Online Submissions",
                    content: "Submission of file online in the Govt portal",
                    heading_class: "w-[220px] sm:w-[152px]",
                    image_class:"w-[65px] h-[61px]",
                    content_class:"w-[220px] sm:w-[160px]",
                },
                {
                    image:dtcpcoordination,
                    heading:" Coordination with DTCP",
                    content: "Follow up in DTCP with the offical and get the approval done",
                    heading_class :"w-[220px] sm:w-[172px]",
                    image_class: "w-[82px] h-[84px]",
                    content_class: "w-[220px] sm:w-[155px]",
                    line: true
                },
                {
                    image: localbody,
                    heading: "Local body coordination",
                    content: "Follow up in the corporation with the officaials and get the approval done",
                    image_class:"w-[64px] h-[78px]",
                    heading_class:"w-[220px] sm:w-[131px]",
                    content_class:"w-[250px] sm:w-[152px]",
                    line: true
                }
            ],
            delivery: [
                {
                    image: approvaldocuments,
                    heading: "Approval documents",
                    content: "Obtaining approval documents as required",
                    heading_class: "w-[220px] sm:w-[179px]",
                    image_class:"w-[66px] h-[59px]",
                    content_class:"w-[220px] sm:w-[151px]",
                },
                {
                    image: validity,
                    heading: "Validity & verification",
                    content: "Ensuring validity and its future oppurtunities if there is a delay in execution",
                    heading_class: "w-[220px] sm:w-[114px]",
                    image_class: "w-[54px] h-[66px]",
                    content_class:"w-[220px] sm:w-[161px]",
                    line: true
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the file",
                    heading_class: "w-[220px] sm:w-[131px]",
                    image_class: "w-[49px] h-[67px]",
                    content_class: "w-[220px] sm:w-[152px]",
                    line: true
                },
            ]
        },

        
        landuse:{
            banner_image:{
                image: landuse_banner,
                title: "Unlocking New Possibilities in Tamil Nadu",
                subtitle: "From Fields to Facilities",
                textposition: "w-[474px] top-[162px] right-[59px]"
            },
            heading:"Land Use Change",
            description:"Are you planning to transform agricultural land into a thriving residential, commercial, industrial, or medical facility? We will help you through the land conversion based on government laws and regulations quickly and efficiently.",
            compliance : [
                {
                    image: approach,
                    heading: "Assessment",
                    content: "Expert assessment of land in conjunction to the latest environment laws that the lands may fall under",
                    heading_class: "w-[159px]",
                    image_class: "w-[66px] h-[70px]",
                    content_class: "w-[193px]"
                },
                {
                    image: feasibility,
                    heading: "Feasibility Study",
                    content: "Approaches that will lead to cost, time and regulatory processes",
                    heading_class: "w-[131px]",
                    image_class:"w-[87px] h-[91px]",
                    content_class: "w-[185px]",
                    line: true,
                },
            ],
            filepreparation: [
                {
                  image: expertopinion,
                  heading:"Legal Opinion",
                  content: "Legal clarity to the property via opinion from expert lawyers",  
                  heading_class: "w-[179px]",
                  image_class:"w-[75px] h-[75px]",
                  content_class: "w-[160px]"
                },
                {
                    image:designdrawing,
                    heading:"Design drawings",
                    content: "Assessment of building plan in accordance with the regulations",
                    heading_class: "w-[150px]",
                    image_class: "w-[86px] h-[73px]",
                    content_class:"w-[160px]",
                    line:true
                },
                {
                    image: NOC,
                    heading: "Undertakings and NOC",
                    content: "No-objection certificates from one of the 13 departments whichever is applicable",
                    heading_class:"w-[223px]",
                    image_class: "w-[56px] h-[74px]",
                    content_class:"w-[182px]",
                    line:true

                }
            ],
            submission: [
                {
                    image: onlinesubmission,
                    heading: "Online Submissions",
                    content: "Submission of file online in the Govt portal",
                    heading_class: "w-[152px]",
                    image_class:"w-[65px] h-[61px]",
                    content_class:"w-[160px]",
                },
                {
                    image:dtcpcoordination,
                    heading:" Coordination with DTCP",
                    content: "Follow up in DTCP with the offical and get the approval done",
                    heading_class : "w-[172px]",
                    image_class: "w-[82px] h-[84px]",
                    content_class: "w-[155px]",
                    line: true
                },
                {
                    image: localbody,
                    heading: "Local body coordination",
                    content: "Follow up in the corporation with the officaials and get the approval done",
                    image_class:"w-[64px] h-[78px]",
                    heading_class:"w-[131px]",
                    content_class:"w-[152px]",
                    line: true
                }
            ],
            delivery: [
                {
                    image: approvaldocuments,
                    heading: "Approval documents",
                    content: "Obtaining approval documents as required",
                    heading_class: "w-[179px]",
                    image_class:"w-[66px] h-[59px]",
                    content_class:"w-[151px]",
                },
                {
                    image: validity,
                    heading: "Validity & verification",
                    content: "Ensuring validity and its future oppurtunities if there is a delay in execution",
                    heading_class: "w-[114px]",
                    image_class: "w-[54px] h-[66px]",
                    content_class:"w-[161px]",
                    line: true
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the file",
                    heading_class: "w-[131px]",
                    image_class: "w-[49px] h-[67px]",
                    content_class: "w-[152px]",
                    line: true
                },
            ]
            
        },
        layoutapproval: {
            banner_image: {
                image: layoutapproval_banner,
                title: "Designing Dreams, Building Futures",
                subtitle: "Layout crafted for Living & Investment",
                textposition: "w-[600px] top-[167px] left-[129px]"
            },
            heading:"Layout Approval",
            description:"Transform a barren land into a thriving housing community with our design principles that optimise land usability and enhance saleability. Our design principles strictly adhere to government mandates, creating a sought-after locality for both Residential living and Investment oppurtunities. ",
            compliance: [
                {
                    image: approach,
                    heading: "Approach and proximity",
                    content: "Assessment of public road access to the land",
                    heading_class: "w-[159px]",
                    image_class: "w-[66px] h-[70px]",
                    content_class: "w-[153px]",
                    line: false
                },
                {
                    image: subdivision,
                    heading: "Sub-division and detailed review",
                    content: "Review of subdivision in compliance to survey records",
                    heading_class: "w-[153px]",
                    image_class: "w-[81.5px] h-[85px]",
                    content_class:"w-[159px]",
                    line: true,
                },
                {
                    image: feasibility,
                    heading: "Feasibility Study",
                    content: "Approaches that will lead to cost, time and regulatory processes",
                    heading_class: "w-[131px]",
                    image_class:"w-[87px] h-[91px]",
                    content_class: "w-[152px]",
                    line: true,
                },
            ],
            filepreparation: [
                {
                  image: expertopinion,
                  heading:"Legal Opinion",
                  content: "Legal clarity to the property via opinion from expert lawyers",  
                  heading_class: "w-[179px]",
                  image_class:"w-[75px] h-[75px]",
                  content_class: "w-[160px]"
                },
                {
                    image:designdrawing,
                    heading:"Design drawings",
                    content: "Assessment of building plan in accordance with the regulations",
                    heading_class: "w-[150px]",
                    image_class: "w-[86px] h-[73px]",
                    content_class:"w-[160px]",
                    line:true
                },
                {
                    image: NOC,
                    heading: "Undertakings and NOC",
                    content: "No-objection certificates from one of the 13 departments whichever is applicable",
                    heading_class:"w-[223px]",
                    image_class: "w-[56px] h-[74px]",
                    content_class:"w-[182px]",
                    line:true

                }
            ],
            submission: [
                {
                    image: onlinesubmission,
                    heading: "Online Submissions",
                    content: "Submission of file online in the Govt portal",
                    heading_class: "w-[152px]",
                    image_class:"w-[65px] h-[61px]",
                    content_class:"w-[160px]",
                },
                {
                    image:dtcpcoordination,
                    heading:" Coordination with DTCP",
                    content: "Follow up in DTCP with the offical and get the approval done",
                    heading_class : "w-[172px]",
                    image_class: "w-[82px] h-[84px]",
                    content_class: "w-[155px]",
                    line: true
                },
                {
                    image: localbody,
                    heading: "Local body coordination",
                    content: "Follow up in the corporation with the officaials and get the approval done",
                    image_class:"w-[64px] h-[78px]",
                    heading_class:"w-[131px]",
                    content_class:"w-[152px]",
                    line: true
                }
            ],
            delivery: [
                {
                    image: approvaldocuments,
                    heading: "Approval documents",
                    content: "Obtaining approval documents as required",
                    heading_class: "w-[179px]",
                    image_class:"w-[66px] h-[59px]",
                    content_class:"w-[151px]",
                },
                {
                    image: validity,
                    heading: "Validity & verification",
                    content: "Ensuring validity and its future oppurtunities if there is a delay in execution",
                    heading_class: "w-[114px]",
                    image_class: "w-[54px] h-[66px]",
                    content_class:"w-[161px]",
                    line: true
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the file",
                    heading_class: "w-[131px]",
                    image_class: "w-[49px] h-[67px]",
                    content_class: "w-[152px]",
                    line: true
                },
            ]
        },
        hacanoc:{
            banner_image:{
                image: hacanoc_banner,
                title: "Your guide to Environmentally cautious Development.",
                subtitle: "Approvals in compliance with environmental regulations.",
                textposition: "w-[703px] top-[132px] right-[150px]"
            },
            heading:"HACA NOC",
            description: "If your assets is in environmentally sensitive areas like hills, waterbodies, etc... you might have to seek approval from government departments to effectively put the Land to use, be it for construction, sale or any other intent to develop. Lands and Lands will help you obtain those approvals.",
            compliance: [
                {
                    image: approach,
                    heading: "Approach and proximity",
                    content: "Assessment of public road access to the land",
                    heading_class: "w-[159px]",
                    image_class: "w-[66px] h-[70px]",
                    content_class: "w-[153px]",
                    line: false
                },
                {
                    image: subdivision,
                    heading: "Sub-division and detailed review",
                    content: "Review of subdivision in compliance to survey records",
                    heading_class: "w-[153px]",
                    image_class: "w-[81.5px] h-[85px]",
                    content_class:"w-[159px]",
                    line: true,
                },
                {
                    image: feasibility,
                    heading: "Feasibility Study",
                    content: "Approaches that will lead to cost, time and regulatory processes",
                    heading_class: "w-[131px]",
                    image_class:"w-[87px] h-[91px]",
                    content_class: "w-[152px]",
                    line: true,
                },
            ],
            filepreparation: [
                {
                  image: expertopinion,
                  heading:"Legal Opinion",
                  content: "Legal clarity to the property via opinion from expert lawyers",  
                  heading_class: "w-[179px]",
                  image_class:"w-[75px] h-[75px]",
                  content_class: "w-[160px]"
                },
                {
                    image:designdrawing,
                    heading:"Design drawings",
                    content: "Assessment of building plan in accordance with the regulations",
                    heading_class: "w-[150px]",
                    image_class: "w-[86px] h-[73px]",
                    content_class:"w-[160px]",
                    line:true
                },
                {
                    image: NOC,
                    heading: "Undertakings and NOC",
                    content: "No-objection certificates from one of the 13 departments whichever is applicable",
                    heading_class:"w-[223px]",
                    image_class: "w-[56px] h-[74px]",
                    content_class:"w-[182px]",
                    line:true

                }
            ],
            submission: [
                {
                    image: onlinesubmission,
                    heading: "Online Submissions",
                    content: "Submission of file online in the Govt portal",
                    heading_class: "w-[152px]",
                    image_class:"w-[65px] h-[61px]",
                    content_class:"w-[160px]",
                },
                {
                    image:dtcpcoordination,
                    heading:" Coordination with DTCP",
                    content: "Follow up in DTCP with the offical and get the approval done",
                    heading_class : "w-[172px]",
                    image_class: "w-[82px] h-[84px]",
                    content_class: "w-[155px]",
                    line: true
                },
                {
                    image: localbody,
                    heading: "Local body coordination",
                    content: "Follow up in the corporation with the officaials and get the approval done",
                    image_class:"w-[64px] h-[78px]",
                    heading_class:"w-[131px]",
                    content_class:"w-[152px]",
                    line: true
                }
            ],
            delivery: [
                {
                    image: approvaldocuments,
                    heading: "Approval documents",
                    content: "Obtaining approval documents as required",
                    heading_class: "w-[179px]",
                    image_class:"w-[66px] h-[59px]",
                    content_class:"w-[151px]",
                },
                {
                    image: validity,
                    heading: "Validity & verification",
                    content: "Ensuring validity and its future oppurtunities if there is a delay in execution",
                    heading_class: "w-[114px]",
                    image_class: "w-[54px] h-[66px]",
                    content_class:"w-[161px]",
                    line: true
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the file",
                    heading_class: "w-[131px]",
                    image_class: "w-[49px] h-[67px]",
                    content_class: "w-[152px]",
                    line: true
                },
            ]
        },

    }
    
    
    
    return (
        <>

            {/*Banner Section*/}
            <Banner 
                img = {data[path]?.banner_image.image}
                heading = {data[path]?.banner_image.title}
                subheading = {data[path]?.banner_image.subtitle}
                alt = {`${path}_bannerimage`}
                textposition={data[path]?.banner_image.textposition}
            />



            {/*Service Description */}
            <div className="max-w-7xl mx-auto mt-28 px-4 lg:px-0 ">
                <h1 className="text-[#17212B] font-[merriweather] text-[35px] text-center max-w-[914px] mx-auto tracking-[1px] leading-[58px] sm:text-[52px]">{data[path]?.heading}</h1>
                <p className="max-w-[900px] text-center font-[merriweather] text-[#757575] text-[18px] mx-auto tracking-[0.48px] leading-[34px] mt-7 sm:text-[22px]">{data[path]?.description}</p>
                

                <div className="max-w-[641px] mx-auto grid grid-cols-2 justify-center px-24 md:px-0 md:grid-cols-4 mt-32 gap-x-20 gap-y-10 md:gap-x-10">
                        <div className="flex flex-col items-center gap-y-5">
                            <img className="w-[80px] h-[62px]" src={Residential} alt="residential_image"/>
                            <p className="text-[#1D1D1F] font-[lato] text-[20px] leading-[23px] tracking-[0.796px]">Residential</p>
                        </div>
                        
                        <div className="flex flex-col items-center gap-y-5">
                            <img className="w-[62px] h-[62px]" src={Industry} alt="residential_image"/>
                            <p className="text-[#1D1D1F] font-[lato] text-[20px] leading-[23px] tracking-[0.796px]">Industry</p>
                        </div>

                        <div className="flex flex-col items-center gap-y-5">
                            <img className="w-[80px] h-[62px]" src={Educational} alt="residential_image"/>
                            <p className="text-[#1D1D1F] font-[lato] text-[20px] leading-[23px] tracking-[0.796px]">Educational</p>
                        </div>
                        <div className="flex flex-col items-center gap-y-5">
                            <img className="w-[79px] h-[62px]" src={Healthcare} alt="residential_image"/>
                            <p className="text-[#1D1D1F] font-[lato] text-[20px] leading-[23px] tracking-[0.796px]">Healthcare</p>
                        </div>

                </div>
            </div>

            {/*Sign Up Instruction Section */}

            <div className="bg-grey my-12 py-24">
                <div className="max-w-7xl mx-auto">
                    <div className="flex flex-col gap-x-20 md:flex-row">
                        {/* < div className="w-full sm:w-1/4 text-font-grey font-[lato] text-[16px] font-semibold leading-[16px] tracking-[0.4px] hidden lg:block">
                           <div className="border-l-2 pl-5 mt-5 "> 
                                <p className="">Document Review & Proposal</p>
                                <p className="my-[38px]">Regulatory and compliance study</p>
                                <p className="my-[38px]">File Preparation</p>
                                <p className="my-[38px]">Submission & Co-ordination</p>
                                <p className="my-[38px]">Approval & Delivery</p>
                            </div>
                        </div> */}
                        
                        <div className="w-full text-center max-w-5xl mx-auto">
                                <h1 className="max-w-[632px] mx-auto text-[#17212B] font-[merriweather] text-[35px] leading-[53.5px] tracking-[1px] sm:text-[47px] ">You'll need a few things to sign up </h1>

                                <div className="flex flex-row justify-center items-start px-4 md:px-0">
                                    <div className="sm:w-1/5 flex flex-col gap-y-7  mt-[70px] sm:mt-[110px]">
                                       <div className="flex flex-row gap-x-4 items-center">
                                            <div className="h-[20px] w-[20px] border-2 border-black"></div>
                                            <p className="font-[Lato] text-font-grey text-[18px] leading-[26.6px] tracking-[0.19px]">Sign-up</p>
                                       </div>
                                       <div className="flex flex-row gap-x-4 items-center">
                                            <div className="h-[20px] w-[20px] border-2 border-black"></div>
                                            <p className="font-[Lato] text-font-grey text-[18px] leading-[26.6px] tracking-[0.19px]">Site Visit</p>
                                       </div>
                                       <div className="flex flex-row gap-x-4 items-center">
                                            <div className="h-[20px] w-[20px] border-2 border-black"></div>
                                            <p className="font-[Lato] text-font-grey text-[18px] leading-[26.6px] tracking-[0.19px]">Proposal</p>
                                       </div>
                                    </div>

                                    <div className="my-auto">
                                        <img className="w-[250px] sm:w-[527px] my-auto" src={mockup} alt="mockup_image" />
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>

    
             {/*Regulatory & Compliance Study */}

            <div className="max-w-7xl mx-auto my-20">
                <div className="mx-auto flex flex-col lg:flex-row sm:gap-x-20 px-4 lg:px-0">
                    <div className="lg:w-1/4"></div>

                    <div className="lg:w-3/4">
                        <h1 className="max-w-[569px] text-[#17212B] font-[merriweather] text-[35px] text-center leading-[53.5px] tracking-[1px] sm:text-[47px] sm:text-left">Regulatory and compliance study </h1>

                        <div className="flex flex-col md:flex-row mt-16 md:mt-20 md:gap-x-28 gap-y-20">
                            {data[path]?.compliance.map((value) => {
                               return (
                                <>
                                <div className="font-[lato] flex flex-col justify-between relative mx-auto sm:mx-0">
                                    <img className="w-[115px] h-[115px] sm:w-[85px] sm:h-[85px]" alt="compliance_icons" src={value.image} />
                                    <h4 className={`text-brown text-[24px] font-bold leading-[32px] tracking-[0.32px] mt-4 sm:text-[19px] sm:leading-[24px] sm:mt-7 ${value.heading_class}`}>{value.heading}</h4>
                                    <p className={`text-font-brown text-[17.5px] leading-[24px] tracking-[0.32px] mt-3 sm:text-[15px] sm:leading-[22px] ${value.content_class}`}>{value.content}</p>
                                    {value.line === true ? <img className="w-[500px] h-[2px] mt-[40px] absolute -top-20 sm:w-[80px] sm:h-[1px] md:top-0 md:-left-[155px]" src={line} alt="Line_image" /> : null}
                                </div>
                                </>
                               )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {/* File Preparation Section */}
            <div className="bg-grey my-20 pt-20 pb-28">
                <div className="max-w-7xl mx-auto">
                    <div className="mx-auto flex flex-col lg:flex-row sm:gap-x-20 px-4 lg:px-0">
                        <div className="lg:w-1/4"></div>

                        <div className="lg:w-3/4">
                        <h1 className="max-w-[569px] text-[#17212B] font-[merriweather] text-center text-[35px] leading-[53.5px] tracking-[1px] sm:text-[47px] sm:text-left">File Preparation</h1>

                        <div className="flex flex-col md:flex-row mt-16 md:mt-20 lg:gap-x-28 gap-y-20">

                            {data[path]?.filepreparation.map((value) => {
                                return (
                                    <div className="font-[lato] flex flex-col mx-auto justify-between relative">
                                        <img className= "w-[115px] h-[115px] sm:w-[85px] sm:h-[85px]" alt="compliance_icons" src={value.image} />
                                        <h4 className={`text-brown text-[24px] font-bold leading-[32px] tracking-[0.32px] mt-4 sm:text-[19px] sm:leading-[24px] sm:mt-7 ${value.heading_class}`}>{value.heading}</h4>
                                        <p className={`text-font-brown text-[17.5px] leading-[24px] tracking-[0.32px] mt-3 sm:text-[15px] sm:leading-[22px] ${value.content_class}`}>{value.content}</p>
                                        {value.line === true ? <img className="w-[500px] h-[2px] mt-[40px] absolute -top-20 sm:w-[80px] sm:h-[1px] md:top-0 md:-left-[120px]" src={line} alt="Line_image" /> : null}
                                    </div>
                                )
                            })}
                        </div>

                        </div>
                    </div>

                </div>
            </div>

            {/* Submission & Co-ordination */}

            <div className="my-16 pt-2 pb-2 sm:my-20 sm:pt-20 sm:pb-16">
                <div className="max-w-7xl mx-auto ">
                    <div className="mx-auto flex flex-col lg:flex-row sm:gap-x-20 px-4 lg:px-0">
                        <div className="lg:w-1/4"></div>

                        <div className="lg:w-3/4">
                            <h1 className="max-w-[606px] text-[#17212B] font-[merriweather] text-center text-[35px] leading-[53.5px] tracking-[1px] sm:text-[47px] sm:text-left">Submission <span className="font-[Lato]">&</span> coordination </h1>

                            <div className="flex flex-col md:flex-row mt-16 sm:mt-20 lg:gap-x-28 gap-y-20">

                                {data[path]?.submission.map((value) => {
                                    return (
                                        <div className="font-[lato] flex flex-col justify-between relative mx-auto">
                                            <img className= "w-[115px] h-[115px] sm:w-[85px] sm:h-[85px]" alt="compliance_icons" src={value.image} />
                                            <h4 className={`text-brown text-[24px] font-bold leading-[32px] tracking-[0.32px] mt-4 sm:text-[19px] sm:leading-[24px] sm:mt-7 ${value.heading_class}`}>{value.heading} hello</h4>
                                            <p className={`text-font-brown text-[17.5px] leading-[24px] tracking-[0.32px] mt-3 sm:text-[15px] sm:leading-[22px] ${value.content_class}`}>{value.content}</p>
                                            {value.line === true ? <img className="w-[500px] h-[2px] mt-[40px] absolute -top-20 sm:w-[80px] sm:h-[1px] md:top-0 md:-left-[155px]" src={line} alt="Line_image" /> : null}
                                        </div>
                                    )
                                })}
                            </div>

                        </div>
                    </div>
                </div>
                <img className="w-full md:h-[688px] mt-10" src={insidebanner} alt="Secondary_Banner_Image" />
            </div>
            


            {/*Approval & Delivery */}
            <div className="max-w-7xl mx-auto mb-20 ">
                <div className="mx-auto flex flex-col lg:flex-row sm:gap-x-20 px-4 lg:px-0">
                    <div className="lg:w-1/4"></div>

                    <div className="lg:w-3/4 ">
                        <h1 className="max-w-[606px] text-[#17212B] font-[merriweather] text-center text-[35px] leading-[53.5px] tracking-[1px] sm:text-[47px] sm:text-left">Approval <span className="font-[Lato]">&</span> delivery </h1>

                        <div className="flex flex-col md:flex-row mt-16 sm:mt-20 lg:gap-x-28 gap-y-20">

                            {data[path]?.delivery.map((value) => {
                                return (
                                    <div className="font-[lato] flex flex-col relative mx-auto">
                                        <img className= "w-[115px] h-[115px] sm:w-[85px] sm:h-[85px]" alt="compliance_icons" src={value.image} />
                                        <h4 className={`text-brown text-[24px] font-bold leading-[32px] tracking-[0.32px] mt-2 sm:text-[19px] sm:leading-[24px] sm:mt-7${value.heading_class}`}>{value.heading}</h4>
                                        <p className={`font-[lato] text-font-brown text-[17.5px] leading-[24px] tracking-[0.32px] mt-3 sm:text-[15px] sm:leading-[22px] ${value.content_class}`}>{value.content}</p>
                                        {value.line === true ? <img className="w-[500px] h-[2px] mt-[40px] absolute -top-20 sm:w-[80px] sm:h-[1px] md:top-0 md:-left-[155px]" src={line} alt="Line_image" /> : null}
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </div>

            <Milestones />

            <Chatwithus />

            {/* <Testimonial /> */}

        </>
    )
}

export default Liasion_Description